import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTrans from './locales/en.json';
import zhTrans from './locales/cn.json';
import itTrans from './locales/it.json';
import spTrans from './locales/sp.json';
import { checkLng, setCoutryLng } from './constants/tool.fn';
import * as i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import LSM from './modules/cache/tool-local-storage';
import { LOCAL_STORAGE_KEYS } from './modules/cache/local-storage.constant';

// Workaround for https://github.com/isaachinman/next-i18next/issues/1781
// tslint:disable
declare module 'i18next' {
  interface TFunction {
    <
      TKeys extends i18next.TFuncKey = string,
      TInterpolationMap extends object = i18next.StringMap
    >(
      key: TKeys,
      options?: i18next.TOptions<TInterpolationMap> | string,
    ): string;
  }
}

// 国际化资源文件
const resources = {
  IT: {
    translation: itTrans
  },
  CN: {
    translation: zhTrans
  },
  EN: {
    translation: enTrans
  },
  SP: {
    translation: spTrans
  }
}
// 浏览器设置语言
const browserLng = setCoutryLng(navigator.language.toUpperCase());
// $ 用户手动设置语言后，记录缓存，下次优先获取缓存
const lng = checkLng(LSM.get(LOCAL_STORAGE_KEYS.LANGUAGE)) || browserLng || 'EN';
LSM.set({ path: LOCAL_STORAGE_KEYS.LANGUAGE, value: lng })
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    resources,
    lng,

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });


export type Resources = keyof (typeof resources);

export default i18n;

// tslint:enable